import { useEffect } from "react";
import ThankYou from "../features/SelfAssessment/screens/Stepper/ThankYouPage";

export default function ThankYouPage() {
  useEffect(() => {
    document.title = "Thank You | PlacedRisk Solutions";
  }, []);

  return <ThankYou />;
}

